import { render, staticRenderFns } from "./InspectorsReports.vue?vue&type=template&id=6d74526d"
import script from "./InspectorsReports.vue?vue&type=script&lang=js"
export * from "./InspectorsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports